export default __webpack_public_path__ + "static/media/pishgiri.bfb5f105.jpg";